import { BILLING_CYCLE, planTypes } from "@/common/constants";
import { computedCallingPlans } from "@/common/service/computers/plans/pbx";
import { groupBy } from "lodash";
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      'getSelectedPlans': 'getSelectedPlans',
      'getUserCurrentSubscriptions': 'getUserCurrentSubscriptions',
      'plancodeMapSubscriptionDisabled': 'plancodeMapSubscriptionDisabled',
      'boughtPlans': 'boughtPlans',
      'basicConfig': 'basicConfig',
    }),
    data_mx_allPlans() {
      return this.planMapFlat.filter(item => item.type === planTypes.ZOOM_PHONE$ADDITIONAL);
    },
    data_mx_selectedPlans() {
      return this.getSelectedPlans.filter(item => item.type === planTypes.ZOOM_PHONE$ADDITIONAL);
    },
    data_mx_boughtPlans() {
      return this.boughtPlans.filter(item => item.type === planTypes.ZOOM_PHONE$ADDITIONAL);
    },
    data_mx_currentBillingCycle() {
      const selectCallingPlan = computedCallingPlans(this.getUserCurrentSubscriptions)[0];
      if (selectCallingPlan) {
        return selectCallingPlan.billing_cycle;
      }
      return BILLING_CYCLE.ANNUAL;
    },
    data_mx_unit() {
      return this.$t(`billing.common.per_billing_cycle.${this.data_mx_currentBillingCycle}`)
    },
    data_mx_cycleMap() {
      return groupBy(this.data_mx_allPlans, 'billing_cycle')
    }
  }
}